module.exports = __webpack_public_path__ + "img/event-solo-venere-janv-mars-2025.e34cda8.jpg";